import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { db, auth, storage } from '../firebase';
import {
  collection, query, orderBy, limit, onSnapshot, addDoc, doc, updateDoc,
  deleteDoc, arrayUnion, arrayRemove, getDoc, serverTimestamp, getDocs, where
} from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { onAuthStateChanged } from 'firebase/auth';
import {
  FiArrowLeft, FiCamera, FiX, FiHeart, FiAward, FiZap, FiThumbsUp,
  FiMessageSquare, FiShare2, FiTarget, FiImage, FiUser, FiActivity, FiUsers,
  FiMoreVertical, FiEdit3, FiTrash2, FiAlertTriangle
} from 'react-icons/fi';
import logo from '../logo_colored_transp_no_text.png';

// --- EGYEDI SVG IKONOK (AZ APP PONTOS IKONJAI ALAPJÁN) ---
const IconTraining = ({ size = 22, color = "#D32F2F" }) => (
  <svg width={size} height={size} viewBox="0 0 300 300" fill={color}>
    <path d="M117.2,33.2c-1.9,1.9 -1.4,3.9 1.5,7 2.4,2.5 2.5,2.9 1.1,4.5 -0.8,1 -3.4,4.9 -5.8,8.8 -2.4,3.8 -7.9,12.6 -12.2,19.4l-7.8,12.4 0,-5.3c0,-20 -24.4,-30 -39.3,-16.1 -9.9,9.1 -9.7,26.1 0.5,34.6 7.5,6.3 18,7.7 25.6,3.5 2.5,-1.4 3.9,-2.7 3.3,-3.3 -0.5,-0.5 0.4,-2.8 2.3,-5.6 1.7,-2.7 3.6,-5.6 4.2,-6.6 1.1,-2 3.4,-1.3 3.4,1.1 0,1.8 -7,12.4 -8.1,12.4 -0.5,-0 -2.5,2.2 -4.5,5l-3.6,5 -20.1,-0c-22.6,-0 -25.8,0.8 -31,6.9 -2.2,2.6 -2.7,4.3 -2.7,8.4 0,10 5.8,15.1 16.7,15.1l6.3,-0 0,20.1c0,19.9 -2.2,41.6 -8.5,83.8 -1.5,10 -1.3,13.5 1.2,17.4 1.8,2.7 7.2,5.3 11,5.3 3.4,-0 8.8,-3.1 10.3,-5.9 0.6,-1.2 3.3,-13.2 6.1,-26.8 2.7,-13.7 5.1,-25.2 5.3,-25.7 0.1,-0.5 1,4.2 1.9,10.5 6.1,42.6 6,42.2 12,46 4.7,2.9 10.9,2.1 15.2,-2.1 1.8,-1.8 3.5,-4.4 3.8,-5.9 0.3,-1.4 0,-8.9 -0.8,-16.6 -1.5,-15.2 -4,-43.6 -5.1,-58 -0.4,-5.6 -0.3,-8.6 0.3,-8 1.8,1.9 20.3,32.1 20.3,33.1 0,0.6 -0.9,1.9 -2,2.9 -2.4,2.1 -2.6,4.8 -0.5,6.5 2.2,1.9 3.7,0.8 10.2,-7.2 13.2,-16.1 22.7,-33.5 27.3,-50.1 2.3,-8.2 5,-24.7 5,-30.7l0,-4 7.8,-0c5.7,0.1 7.2,0.3 6,1.1 -2.1,1.2 -2.4,4.5 -0.6,5.1 1.3,0.5 15.4,-5.7 17.5,-7.6 0.7,-0.6 0.9,-1.6 0.5,-2.2 -1,-1.7 -14.8,-8.4 -17.2,-8.4 -2.3,-0 -2.7,2.8 -0.7,4.9 1,1.1 0.9,1.3 -0.6,0.7 -1,-0.3 -4.5,-0.6 -7.8,-0.6l-5.9,-0 0,-3.6c0,-5.4 -3.7,-22.4 -6.6,-30.6 -5.7,-15.8 -17,-35.3 -26.9,-46.6 -4.8,-5.4 -6.2,-6.1 -8.3,-4zM130.5,55.9c10,15.2 18,35.6 20.9,53.8l1.3,8.3 -29.4,-0 -29.4,-0 -3.2,-3.3c-1.8,-1.9 -3.8,-3.6 -4.5,-3.8 -0.9,-0.3 3.5,-8 13.4,-23.4 8.1,-12.7 17,-26.7 19.7,-31.2 2.8,-4.5 5.4,-8 5.8,-7.7 0.4,0.2 2.8,3.5 5.4,7.3zM79,67.2c5.7,3.9 7.5,7.2 7.5,13.8 0,6.6 -1.8,9.9 -7.5,13.7 -6.7,4.6 -17.6,1.8 -22.2,-5.6 -4.6,-7.4 -1.5,-18.6 6.3,-22.4 5,-2.4 11.9,-2.2 15.9,0.5zM84.4,119.1c1.5,1.2 2.6,3 2.6,4.4 0,5.8 -8.2,7.9 -35.6,9.1 -14.3,0.6 -16.1,0.5 -17.7,-1 -4.2,-4.2 -3.1,-10.2 2.4,-12.9 2.8,-1.4 6.9,-1.7 24.5,-1.7 19.9,-0 21.3,0.1 23.8,2.1zM158,120.6c1.1,1.2 1,1.8 -0.4,3.2 -1.6,1.6 -1.8,1.6 -3.1,-0.2 -1.1,-1.4 -1.2,-2.3 -0.4,-3.3 1.5,-1.7 2.4,-1.6 3.9,0.3zM181.6,120.5c1.9,1.5 1.9,1.5 0,3 -2.5,1.9 -5,1.9 -6.6,-0 -3,-3.6 2.5,-6.2 6.6,-3zM153,128.5c0,1.9 -0.1,3.5 -0.2,3.5 -0.2,-0 -11.1,1.1 -24.3,2.5 -13.2,1.4 -26.3,2.5 -29.1,2.5 -6.5,-0 -7.7,1.4 -7.2,8 0.1,2.7 0.1,5 -0.2,4.9 -0.3,-0 -2,-3 -3.9,-6.7 -2.6,-5.1 -3,-6.7 -2,-7.1 2.6,-0.8 7.9,-6.9 7.9,-9 0,-2.1 0.2,-2.1 29.5,-2.1l29.5,-0 0,3.5zM81.5,143.1c1.4,2.7 4.4,7.9 6.5,11.5 4,6.4 4,6.5 4,16.9 0,9 2.8,44.4 5.9,74 0.8,7.2 0.7,9.4 -0.5,11.2 -1.9,3 -5,3.8 -7.9,1.9 -2.8,-1.8 -2.2,0.9 -8.1,-39.1 -2.6,-17.6 -5.1,-33 -5.6,-34.3 -0.9,-2.6 -4.6,-2.7 -5.9,-0.2 -0.4,0.8 -3.8,17.2 -7.6,36.4 -6.4,32.8 -7,35 -9.4,36.9 -2.1,1.5 -3.1,1.7 -4.8,0.8 -3.8,-2.1 -4,-4 -2,-18.6 7.8,-55.6 7.9,-56.2 7.9,-78.7l0,-21.6 8.8,-0.7c4.8,-0.3 9.4,-0.8 10.2,-0.9 5,-1.1 6,-0.6 8.5,4.5zM151.5,143.2c-3.2,19.2 -10.4,36.1 -22.9,53.6l-4.5,6.4 -1.7,-3.4c-0.9,-1.8 -6.5,-11 -12.4,-20.3l-10.7,-17 0.1,-9.1 0.1,-9.1 9.5,-0.7c7.4,-0.6 38.1,-3.8 42.3,-4.5 0.5,-0 0.6,1.8 0.2,4.1zM94.8,155.2l-0.3,2.3 -1.3,-2.3c-1.1,-1.9 -1.1,-2.6 0,-3.9 1.2,-1.5 1.3,-1.5 1.6,-0 0.2,0.9 0.2,2.7 0,3.9zM98.5,169c0.7,2.1 0,4 -1.6,4 -0.5,-0 -0.9,-1.4 -0.9,-3 0,-3.4 1.5,-4 2.5,-1zM74.6,201.5l0.6,6 -2.7,-0c-2.7,-0 -2.7,-0.1 -2.1,-5.2 1.2,-10.3 3.2,-10.6 4.2,-0.8z"/>
    <path d="M217.7,74.1c-15.1,3.5 -31.5,19.4 -35.2,34 -0.5,2.1 -0.1,2.7 2.9,4.2 3.4,1.6 3.6,1.6 3.6,-0.2 0,-1 1.6,-5 3.5,-8.8 4.3,-8.7 11.2,-15.3 20.3,-19.6 6.1,-2.9 7.6,-3.2 16.3,-3.2 8.9,-0 9.9,0.2 17,3.7 9.2,4.5 16,11.2 20.2,19.8 3,6.1 3.2,7 3.2,18 0,10.5 -0.2,12 -2.8,17.1 -7.9,16.1 -22.4,24.6 -40.1,23.7 -16.7,-0.9 -32,-12.4 -36.8,-27.6 -0.7,-2.3 -1.6,-4.2 -2.1,-4.2 -1.4,-0 -5.7,3.2 -5.7,4.2 0,2.8 6.7,14.4 11,19.2 9.9,10.8 21.1,15.6 36,15.6 19.4,-0 36.2,-10.4 44.1,-27.5 12.8,-27.3 -2.6,-60.4 -31.6,-68 -6.4,-1.6 -17.7,-1.8 -23.8,-0.4z"/>
    <path d="M222.5,92.9c-13.7,3.6 -22.8,15.2 -22.8,29.2 0,25.8 31.6,38.8 49.9,20.5 6,-6.1 8.4,-12.2 8.4,-21.5 -0.1,-11.1 -5.9,-20.4 -16.2,-25.7 -5.2,-2.6 -14.3,-3.8 -19.3,-2.5zM236.1,100.1c13.3,4 19.7,21 12.6,33.2 -5.1,8.6 -14.8,12.7 -24.8,10.6 -6.6,-1.4 -15.1,-9.2 -16.8,-15.4 -4.9,-17.8 11.3,-33.6 29,-28.4z"/>
    <path d="M221.8,113.9c-2.9,2.6 -3.3,3.5 -3.3,8.1 0,4.6 0.4,5.5 3.3,8.1 4.7,4.3 10.2,4.1 14.8,-0.5 2.8,-2.8 3.4,-4.2 3.4,-7.6 0,-3.4 -0.6,-4.8 -3.4,-7.6 -4.6,-4.6 -10.1,-4.8 -14.8,-0.5zM232,119c2.4,2.4 2.4,3 0.7,5.4 -0.9,1.2 -2.3,1.7 -4.2,1.4 -2.5,-0.2 -3.1,-0.8 -3.3,-3.3 -0.3,-1.9 0.2,-3.3 1.4,-4.2 2.4,-1.7 3,-1.7 5.4,0.7z"/>
  </svg>
);

const IconTrophies = ({ size = 22, color = "#D32F2F" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M19,5h-2V3H7v2H5C3.9,5 3,5.9 3,7v1c0,2.55 1.92,4.63 4.39,4.94c0.63,1.5 1.98,2.63 3.61,2.96V19H7v2h10v-2h-4v-3.1c1.63,-0.33 2.98,-1.46 3.61,-2.96C19.08,12.63 21,10.55 21,8V7C21,5.9 20.1,5 19,5zM5,8V7h2v3.82C5.84,10.4 5,9.3 5,8zM19,8c0,1.3 -0.84,2.4 -2,2.82V7h2V8z"/>
  </svg>
);

const SocialFeed = () => {
  const navigate = useNavigate();
  const [currentUser, setCurrentUser] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [feedTab, setFeedTab] = useState('ALL'); // 'ALL' vs 'MY_SHARES'

  // --- POSZTOLÓ DOBOZ ÁLLAPOTOK ---
  const [caption, setCaption] = useState('');
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [isPublishing, setIsPublishing] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const fileInputRef = useRef(null);

  // --- 3 PÖTTY OPCIÓK & SZERKESZTÉS/TÖRLEŚ ÁLLAPOTOK ---
  const [activeMenuPostId, setActiveMenuPostId] = useState(null);

  const [editingPost, setEditingPost] = useState(null);
  const [editCaptionInput, setEditCaptionInput] = useState('');
  const [editImageFile, setEditImageFile] = useState(null);
  const [editImagePreview, setEditImagePreview] = useState(null);
  const [isUpdatingPost, setIsUpdatingPost] = useState(false);
  const editFileInputRef = useRef(null);

  const [postToDelete, setPostToDelete] = useState(null);
  const [attachedWorkout, setAttachedWorkout] = useState(() => {
    try {
      const saved = sessionStorage.getItem('selected_workout_to_share');
      if (saved) {
        sessionStorage.removeItem('selected_workout_to_share');
        return JSON.parse(saved);
      }
    } catch (e) {}
    return null;
  });

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // 1. Auth állapot és profil betöltése
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setCurrentUser(user);
      if (user) {
        try {
          const userDoc = await getDoc(doc(db, "users", user.uid));
          if (userDoc.exists()) {
            setUserProfile(userDoc.data());
          } else {
            const clubDoc = await getDoc(doc(db, "Clubs", user.uid));
            if (clubDoc.exists()) {
              setUserProfile(clubDoc.data());
            }
          }
        } catch (e) {
          console.error("Hiba a profil betöltésekor:", e);
        }
      }
    });
    return () => unsubscribe();
  }, []);

  // 2. Hírfolyam posztok valós idejű betöltése (az Android App FullFriendFeedActivity.kt 1:1 mintájára)
  useEffect(() => {
    setLoading(true);

    const loadFeed = async () => {
      const loadedPosts = [];
      const postIdsSet = new Set();

      // A. BAZIS POSZTOK LEKÉRDEZÉSE A GLOBÁLIS POSTS GYŰJTEMÉNYBŐL
      try {
        const qPosts = query(
          collection(db, "posts"),
          orderBy("createdAt", "desc"),
          limit(30)
        );
        const postsSnap = await getDocs(qPosts);
        postsSnap.forEach((docSnap) => {
          loadedPosts.push({ id: docSnap.id, ...docSnap.data() });
          postIdsSet.add(docSnap.id);
        });
      } catch (e) {}

      // B. AMIKOR BE VAN JELENTKEZVE A FELHASZNÁLÓ:
      if (currentUser) {
        // 1. SAJÁT MEGOSZTOTT EDZÉSEK ÉS FOTÓK (users/{myUid}/workouts)
        try {
          const myWorkoutsRef = collection(db, "users", currentUser.uid, "workouts");
          const mySnap = await getDocs(query(myWorkoutsRef, limit(20)));
          mySnap.forEach(docSnap => {
            if (!postIdsSet.has(docSnap.id)) {
              const data = docSnap.data();
              if (data.shared || data.isShared || data.caption || data.imageUrl) {
                loadedPosts.push({ id: docSnap.id, authorUid: currentUser.uid, userId: currentUser.uid, ...data });
                postIdsSet.add(docSnap.id);
              }
            }
          });
        } catch (e) {}

        // 2. IGAZOLT BARÁTOK MEGOSZTOTT EDZÉSEI ÉS FOTÓI (friends/{myUid}/userFriends -> users/{friendId}/workouts)
        try {
          const friendsRef = collection(db, "friends", currentUser.uid, "userFriends");
          const friendsSnap = await getDocs(friendsRef);

          for (const friendDoc of friendsSnap.docs) {
            const friendId = friendDoc.id;
            if (friendId === currentUser.uid) continue;

            try {
              const friendWorkoutsRef = collection(db, "users", friendId, "workouts");
              const friendSnap = await getDocs(query(friendWorkoutsRef, where("shared", "==", true), limit(20)));
              friendSnap.forEach(docSnap => {
                if (!postIdsSet.has(docSnap.id)) {
                  const data = docSnap.data();
                  loadedPosts.push({ id: docSnap.id, authorUid: friendId, userId: friendId, ...data });
                  postIdsSet.add(docSnap.id);
                }
              });
            } catch (fErr) {}
          }
        } catch (e) {}

        // 3. KÖVETETT EGYESÜLETEK VERSENY-POSZTJAI (users/{myUid}/followedClubs -> Clubs/{clubId}/posts)
        try {
          const followedClubsRef = collection(db, "users", currentUser.uid, "followedClubs");
          const clubsSnap = await getDocs(followedClubsRef);

          for (const clubDoc of clubsSnap.docs) {
            const clubId = clubDoc.id;
            try {
              const clubPostsRef = collection(db, "Clubs", clubId, "posts");
              const clubSnap = await getDocs(query(clubPostsRef, limit(20)));
              clubSnap.forEach(docSnap => {
                if (!postIdsSet.has(docSnap.id)) {
                  const data = docSnap.data();
                  loadedPosts.push({
                    id: docSnap.id,
                    authorUid: data.authorUid || clubId,
                    userId: clubId,
                    isClubPost: true,
                    ...data
                  });
                  postIdsSet.add(docSnap.id);
                }
              });
            } catch (cErr) {}

            try {
              const clubWorkoutsRef = collection(db, "users", clubId, "workouts");
              const clubWorkoutsSnap = await getDocs(query(clubWorkoutsRef, limit(20)));
              clubWorkoutsSnap.forEach(docSnap => {
                if (!postIdsSet.has(docSnap.id)) {
                  const data = docSnap.data();
                  loadedPosts.push({
                    id: docSnap.id,
                    authorUid: clubId,
                    userId: clubId,
                    isClubPost: true,
                    ...data
                  });
                  postIdsSet.add(docSnap.id);
                }
              });
            } catch (cErr) {}
          }
        } catch (e) {}
      }

      // C. PROFIL ADATOK DINAMIKUS FELOLDÁSA (VALÓDI NÉV ÉS KÉP DOKUMENTUMONKÉNT)
      const userProfilesCache = {};
      const enrichedPosts = [];

      for (const p of loadedPosts) {
        const uId = p.authorUid || p.userId || p.fromUserId;
        let aName = p.authorName;
        let aImage = p.authorImage;

        if (uId && (!aName || aName === 'Íjász' || !aImage)) {
          if (!userProfilesCache[uId]) {
            try {
              const uDoc = await getDoc(doc(db, "users", uId));
              if (uDoc.exists()) {
                const uData = uDoc.data();
                const realName = `${uData.lastName || ''} ${uData.firstName || ''}`.trim() || uData.displayName;
                const realImage = uData.profileImageUrl || uData.photoURL || null;
                userProfilesCache[uId] = { name: realName, image: realImage };
              }
            } catch (e) {}
          }

          if (userProfilesCache[uId]) {
            if (!aName || aName === 'Íjász') aName = userProfilesCache[uId].name || aName;
            if (!aImage) aImage = userProfilesCache[uId].image || aImage;
          }
        }

        const rawTitle = p.title || '';
        const cleanTitle = rawTitle.replace(/^[🏹\s]*verseny:\s*/i, '');

        enrichedPosts.push({
          ...p,
          title: cleanTitle,
          authorName: aName || 'Íjász',
          authorImage: aImage || null,
          authorUid: uId
        });
      }

      enrichedPosts.sort((a, b) => {
        const timeA = a.createdAt?.seconds || (a.createdAt?.toDate ? Math.floor(a.createdAt.toDate().getTime()/1000) : 0);
        const timeB = b.createdAt?.seconds || (b.createdAt?.toDate ? Math.floor(b.createdAt.toDate().getTime()/1000) : 0);
        return timeB - timeA;
      });

      setPosts(enrichedPosts);
      setLoading(false);
    };

    loadFeed();
  }, [currentUser]);

  // --- KÉP KIVÁLASZTÁSA (ÚJ POSZTHOZ) ---
  const handleImageSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleRemoveImage = () => {
    setImageFile(null);
    setImagePreview(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  // --- POSZT BEKÜLDÉSE ---
  const handlePublishPost = async (e) => {
    e.preventDefault();
    if (!currentUser) {
      alert("A posztoláshoz kérjük jelentkezz be!");
      return;
    }

    if (!caption.trim() && !imageFile) {
      alert("Írj be üzenetet vagy tölts fel egy fotót!");
      return;
    }

    setIsPublishing(true);
    try {
      let uploadedImageUrl = null;

      if (imageFile) {
        const fileExt = imageFile.name.split('.').pop() || 'jpg';
        const imageRef = ref(storage, `shared_images/${currentUser.uid}/post_${Date.now()}.${fileExt}`);
        await uploadBytes(imageRef, imageFile);
        uploadedImageUrl = await getDownloadURL(imageRef);
      }

      const authorName = userProfile
        ? (`${userProfile.lastName || ''} ${userProfile.firstName || ''}`.trim() || userProfile.clubName || currentUser.displayName || 'Íjász')
        : (currentUser.displayName || 'Íjász');
      const authorImage = userProfile?.profileImageUrl || userProfile?.logoUrl || currentUser.photoURL || null;

      const newPostData = {
        ...(attachedWorkout || {}),
        shared: true,
        isShared: true,
        authorName,
        authorUid: currentUser.uid,
        userId: currentUser.uid,
        authorImage,
        caption: caption.trim() || attachedWorkout?.workoutName || '',
        customNote: caption.trim(),
        content: caption.trim() || attachedWorkout?.workoutName || '',
        imageUrl: uploadedImageUrl || attachedWorkout?.imageUrl || null,
        createdAt: serverTimestamp(),
        likes: [],
        congrats: [],
        wow: [],
        go: [],
        going: [],
        interested: [],
        isClubPost: false
      };

      // MAX 5 POSZTOS KORLÁT ELLENŐRZÉSE ÉS RÉGI POSZTOK AUTOMATIKUS TÖRLESE (AZ APP 1:1 LOGIKÁJA)
      try {
        const mySharedWorkoutsRef = collection(db, "users", currentUser.uid, "workouts");
        const sharedSnap = await getDocs(query(mySharedWorkoutsRef, where("shared", "==", true)));
        const sharedDocs = sharedSnap.docs.map(d => ({ id: d.id, ...d.data() }));

        sharedDocs.sort((a, b) => {
          const timeA = a.createdAt?.seconds || (a.createdAt?.toDate ? Math.floor(a.createdAt.toDate().getTime()/1000) : 0);
          const timeB = b.createdAt?.seconds || (b.createdAt?.toDate ? Math.floor(b.createdAt.toDate().getTime()/1000) : 0);
          return timeA - timeB;
        });

        if (sharedDocs.length >= 5) {
          const howManyToRemove = sharedDocs.length - 4;
          const itemsToRemove = sharedDocs.slice(0, howManyToRemove);

          for (const oldDoc of itemsToRemove) {
            try {
              await deleteDoc(doc(db, "users", currentUser.uid, "workouts", oldDoc.id));
            } catch (delErr) {}
          }
        }
      } catch (checkErr) {
        console.warn("Max poszt korlát ellenőrzési hiba:", checkErr);
      }

      // Mentés az íjász saját adatlapjára (ahogyan az Android App elvárja)
      const docRef = await addDoc(collection(db, "users", currentUser.uid, "workouts"), newPostData);

      const createdPost = {
        id: docRef.id,
        ...newPostData,
        authorName,
        authorImage,
        authorUid: currentUser.uid,
        createdAt: new Date()
      };

      setPosts(prev => [createdPost, ...prev]);

      setCaption('');
      setImageFile(null);
      setImagePreview(null);
      setAttachedWorkout(null);
      if (fileInputRef.current) fileInputRef.current.value = "";
    } catch (err) {
      console.error("Hiba a posztoláskor:", err);
      alert("Hiba történt a poszt elküldésekor.");
    } finally {
      setIsPublishing(false);
    }
  };

  // --- REAKCIÓ KEZELÉSE (OPTIMISTA AZONNALI UI FRISSÍTÉSSELE) ---
  const handleToggleReaction = async (post, reactionType) => {
    if (!currentUser) {
      alert("A reakciókhoz kérjük jelentkezz be!");
      return;
    }

    // 1. OPTIMISTA UI FRISSÍTÉS (0 ms REAKCIÓMEGJELENÉS A KÉPERNYŐN)
    const currentList = Array.isArray(post[reactionType]) ? post[reactionType] : [];
    const hasReacted = currentList.includes(currentUser.uid);
    const updatedList = hasReacted
      ? currentList.filter(uid => uid !== currentUser.uid)
      : [...currentList, currentUser.uid];

    setPosts(prev => prev.map(p => {
      if (p.id === post.id) {
        return { ...p, [reactionType]: updatedList };
      }
      return p;
    }));

    // 2. FIRESTORE MENTÉS A HÁTTÉRBEN
    try {
      const postRef = doc(db, "users", post.authorUid || currentUser.uid, "workouts", post.id);

      if (hasReacted) {
        await updateDoc(postRef, {
          [reactionType]: arrayRemove(currentUser.uid)
        });
      } else {
        await updateDoc(postRef, {
          [reactionType]: arrayUnion(currentUser.uid)
        });
      }
    } catch (e) {
      console.error("Hiba a reakció módosításakor:", e);
    }
  };

  // --- POSZT SZERKESZTÉSE KÉPPEL ---
  const handleOpenEditModal = (post) => {
    setEditingPost(post);
    setEditCaptionInput(post.caption || post.content || '');
    setEditImagePreview(post.imageUrl || null);
    setEditImageFile(null);
    setActiveMenuPostId(null);
  };

  const handleEditImageSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      setEditImageFile(file);
      setEditImagePreview(URL.createObjectURL(file));
    }
  };

  const handleRemoveEditImage = () => {
    setEditImageFile(null);
    setEditImagePreview(null);
    if (editFileInputRef.current) editFileInputRef.current.value = "";
  };

  const handleSavePostEdit = async () => {
    if (!editingPost || !currentUser) return;

    setIsUpdatingPost(true);
    try {
      let finalImageUrl = editImagePreview;

      // Ha új képet választott ki
      if (editImageFile) {
        const fileExt = editImageFile.name.split('.').pop() || 'jpg';
        const imageRef = ref(storage, `shared_images/${currentUser.uid}/post_${Date.now()}.${fileExt}`);
        await uploadBytes(imageRef, editImageFile);
        finalImageUrl = await getDownloadURL(imageRef);
      }

      const updatedFields = {
        caption: editCaptionInput.trim(),
        content: editCaptionInput.trim(),
        customNote: editCaptionInput.trim(),
        imageUrl: finalImageUrl,
        lastUpdated: serverTimestamp()
      };

      // Mentés Firestore-ba a users/{uid}/workouts alá
      const postRef = doc(db, "users", currentUser.uid, "workouts", editingPost.id);
      await updateDoc(postRef, updatedFields);

      // Helyi állapot frissítése
      setPosts(prev => prev.map(p => p.id === editingPost.id ? { ...p, ...updatedFields } : p));
      setEditingPost(null);
      alert("Bejegyzés sikeresen frissítve! 🏹✅");
    } catch (e) {
      console.error("Hiba a poszt frissítésekor:", e);
      alert("Hiba történt a frissítés során.");
    } finally {
      setIsUpdatingPost(false);
    }
  };

  // --- POSZT TÖRLESE ---
  const handleConfirmDeletePost = async () => {
    if (!postToDelete || !currentUser) return;

    try {
      const postRef = doc(db, "users", currentUser.uid, "workouts", postToDelete.id);
      await deleteDoc(postRef);

      setPosts(prev => prev.filter(p => p.id !== postToDelete.id));
      setPostToDelete(null);
      alert("Bejegyzés sikeresen törölve! 🗑️");
    } catch (e) {
      console.error("Hiba a törléskor:", e);
      alert("Hiba történt a törlés során.");
    }
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return 'Most';
    try {
      const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
      return date.toLocaleDateString('hu-HU', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
    } catch (e) {
      return 'Nemrég';
    }
  };

  const displayedPosts = posts.filter(post => {
    const myUid = currentUser?.uid;
    const authorUid = post.authorUid || post.userId || post.fromUserId;

    if (feedTab === 'MY_SHARES') {
      // Saját megosztások fül: KIZÁRÓLAG a saját bejegyzéseid!
      return Boolean(myUid && authorUid === myUid);
    } else {
      // Közösség fül: KIZÁRÓLAG az igazolt barátaid és egyesületeid bejegyzései!
      return Boolean(authorUid !== myUid);
    }
  });

  return (
    <div style={{ ...pageStyle, padding: isMobile ? '12px 10px 80px 10px' : '20px 20px 80px 20px' }} className="force-light-theme">
      {/* FEJLÉC */}
      <div style={{ ...headerStyle, justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          <button style={backButtonStyle} onClick={() => navigate('/')}>
            <FiArrowLeft size={22} />
          </button>
          <h2 style={{ margin: 0, color: '#b30000', fontSize: '1.3rem', fontWeight: 'bold' }}>Közösség</h2>
        </div>

        {/* BARÁTOK IKON (SÖTÉTSZÜRKE LEKEREKÍTETT DOBOZ) */}
        <button
          onClick={() => navigate('/baratok')}
          style={{
            backgroundColor: '#282828',
            color: '#ffffff',
            border: 'none',
            borderRadius: '10px',
            padding: '8px 10px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 2px 6px rgba(0,0,0,0.15)'
          }}
          title="Barátok és Barátkérelmek"
        >
          <FiUsers size={20} color="#ffffff" />
        </button>
      </div>

      <div style={{ maxWidth: '650px', margin: '0 auto', display: 'flex', flexDirection: 'column', gap: '20px' }}>
        {/* POSZTOLÓ DOBOZ (KOMPAKT ELRENDEZÉS: PROFIL KÉP BALRA, ÜZENETMEZŐ JOBBRA, NÉV NÉLKÜL) */}
        <div style={cardStyle}>
          {currentUser ? (
            <form onSubmit={handlePublishPost}>
              <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
                <div style={{ ...avatarStyle, flexShrink: 0, marginTop: '2px' }}>
                  {userProfile?.profileImageUrl || userProfile?.logoUrl || currentUser?.photoURL ? (
                    <img src={userProfile?.profileImageUrl || userProfile?.logoUrl || currentUser?.photoURL} alt="" style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }} />
                  ) : (
                    <FiUser size={20} color="#888" />
                  )}
                </div>
                <textarea
                  value={caption}
                  onChange={(e) => setCaption(e.target.value)}
                  placeholder="Mi jár a fejedben...?"
                  style={{ ...textareaStyle, flex: 1, minHeight: '65px' }}
                  rows={2}
                />
              </div>

              {/* KÉP ELŐNÉZET */}
              {imagePreview && (
                <div style={{ position: 'relative', marginTop: '10px', borderRadius: '8px', overflow: 'hidden', border: '1px solid #eee' }}>
                  <img src={imagePreview} alt="Preview" style={{ width: '100%', maxHeight: '250px', objectFit: 'cover' }} />
                  <button
                    type="button"
                    onClick={handleRemoveImage}
                    style={removeImageButtonStyle}
                  >
                    <FiX size={16} />
                  </button>
                </div>
              )}

              {/* CSATOLT EDZÉS ELŐNÉZET */}
              {attachedWorkout && (
                <div style={{ position: 'relative', marginTop: '10px', padding: '12px', backgroundColor: '#fff5f5', borderRadius: '8px', border: '1px solid #feb2b2', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <div>
                    <div style={{ fontWeight: 'bold', color: '#b30000', fontSize: '0.9rem' }}>🏹 {attachedWorkout.workoutName || 'Edzés'}</div>
                    <div style={{ fontSize: '0.8rem', color: '#555', marginTop: '2px' }}>Pontszám: <strong>{attachedWorkout.totalScore || 0}</strong> | Átlag: <strong>{attachedWorkout.averageArrowScore?.toFixed(2) || '0.00'}</strong></div>
                  </div>
                  <button
                    type="button"
                    onClick={() => setAttachedWorkout(null)}
                    style={removeImageButtonStyle}
                  >
                    <FiX size={16} />
                  </button>
                </div>
              )}

              {/* ESZKÖZTÁR (GALÉRIA, EDZÉS, TRÓFEA) ÉS BEKÜLDÉS GOMB */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '15px', paddingTop: '10px', borderTop: '1px solid #f0f0f0' }}>
                <div style={{ display: 'flex', gap: '22px', alignItems: 'center' }}>
                  {/* GALÉRIA */}
                  <label style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2px', cursor: 'pointer' }}>
                    <FiImage size={22} color="#D32F2F" />
                    <span style={{ fontSize: '0.7rem', fontWeight: 'bold', color: '#555' }}>Galéria</span>
                    <input
                      ref={fileInputRef}
                      type="file"
                      accept="image/*"
                      onChange={handleImageSelect}
                      style={{ display: 'none' }}
                    />
                  </label>

                  {/* EDZÉS */}
                  <div
                    onClick={() => {
                      sessionStorage.setItem('selecting_workout_for_share', 'true');
                      navigate('/edzeseim');
                    }}
                    style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2px', cursor: 'pointer' }}
                  >
                    <IconTraining size={22} color="#D32F2F" />
                    <span style={{ fontSize: '0.7rem', fontWeight: 'bold', color: '#555' }}>Edzés</span>
                  </div>

                  {/* TRÓFEA */}
                  <div
                    onClick={() => alert("Hamarosan elérhető a trófeák közvetlen megosztása!")}
                    style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2px', cursor: 'pointer' }}
                  >
                    <IconTrophies size={22} color="#D32F2F" />
                    <span style={{ fontSize: '0.7rem', fontWeight: 'bold', color: '#555' }}>Trófea</span>
                  </div>
                </div>

                <button
                  type="submit"
                  disabled={isPublishing || (!caption.trim() && !imageFile)}
                  style={{
                    ...submitButtonStyle,
                    opacity: (isPublishing || (!caption.trim() && !imageFile)) ? 0.6 : 1,
                    cursor: (isPublishing || (!caption.trim() && !imageFile)) ? 'not-allowed' : 'pointer'
                  }}
                >
                  {isPublishing ? 'Posztolás...' : 'Megosztás'}
                </button>
              </div>
            </form>
          ) : (
            <div style={{ textAlign: 'center', padding: '15px 0' }}>
              <p style={{ color: '#666', fontSize: '0.9rem', marginBottom: '10px' }}>
                Jelentkezz be az ArcheryNexus fiókodba a posztoláshoz és a reakciókhoz!
              </p>
              <Link to="/login" style={loginButtonStyle}>Bejelentkezés</Link>
            </div>
          )}
        </div>

        {/* FÜL-VÁLTÓ SÁV (KÖZÖSSÉG VS SAJÁT MEGOSZTÁSOK) */}
        <div style={{ display: 'flex', borderBottom: '2px solid #e0e0e0', backgroundColor: 'white', borderRadius: '12px 12px 0 0', overflow: 'hidden' }}>
          <button
            type="button"
            onClick={() => setFeedTab('ALL')}
            style={{
              flex: 1,
              padding: '12px 0',
              backgroundColor: 'transparent',
              border: 'none',
              borderBottom: feedTab === 'ALL' ? '3px solid #b30000' : '3px solid transparent',
              color: feedTab === 'ALL' ? '#b30000' : '#666',
              fontWeight: 'bold',
              fontSize: '0.9rem',
              cursor: 'pointer',
              transition: 'all 0.2s ease'
            }}
          >
            👥 Közösség
          </button>
          <button
            type="button"
            onClick={() => setFeedTab('MY_SHARES')}
            style={{
              flex: 1,
              padding: '12px 0',
              backgroundColor: 'transparent',
              border: 'none',
              borderBottom: feedTab === 'MY_SHARES' ? '3px solid #b30000' : '3px solid transparent',
              color: feedTab === 'MY_SHARES' ? '#b30000' : '#666',
              fontWeight: 'bold',
              fontSize: '0.9rem',
              cursor: 'pointer',
              transition: 'all 0.2s ease'
            }}
          >
            👤 Saját megosztások
          </button>
        </div>

        {/* HÍRFOLYAM LISTA */}
        {loading ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#b30000', fontWeight: 'bold' }}>
            Hírfolyam töltése... 🏹
          </div>
        ) : displayedPosts.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#888', fontStyle: 'italic', backgroundColor: 'white', borderRadius: '12px' }}>
            {feedTab === 'MY_SHARES'
              ? 'Még nincsenek saját megosztásaid. Használd a fenti dobozt az első posztod közzétételéhez! 🏹'
              : 'Még nincsenek közösségi bejegyzések. Légy te az első, aki posztol! 🏹'}
          </div>
        ) : (
          displayedPosts.map((post) => {
            const isClub = post.isClubPost === true;
            const isMyPost = Boolean(currentUser && (post.authorUid === currentUser.uid || post.userId === currentUser.uid || post.fromUserId === currentUser.uid));

            const likesCount = (post.likes || []).length;
            const congratsCount = (post.congrats || []).length;
            const wowCount = (post.wow || []).length;
            const goCount = (post.go || []).length;
            const goingCount = (post.going || []).length;
            const interestedCount = (post.interested || []).length;

            const hasLiked = currentUser && (post.likes || []).includes(currentUser.uid);
            const hasCongrats = currentUser && (post.congrats || []).includes(currentUser.uid);
            const hasWow = currentUser && (post.wow || []).includes(currentUser.uid);
            const hasGo = currentUser && (post.go || []).includes(currentUser.uid);
            const hasGoing = currentUser && (post.going || []).includes(currentUser.uid);
            const hasInterested = currentUser && (post.interested || []).includes(currentUser.uid);

            return (
              <div key={post.id} style={{
                ...cardStyle,
                position: 'relative',
                border: isClub ? '2px solid #b30000' : 'none'
              }}>
                {/* FEJLÉC */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <div style={avatarStyle}>
                      {post.authorImage ? (
                        <img src={post.authorImage} alt="" style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }} />
                      ) : (
                        <FiUser size={18} color="#888" />
                      )}
                    </div>
                    <div>
                      <div style={{ fontWeight: 'bold', fontSize: '0.95rem', color: isClub ? '#b30000' : '#333' }}>
                        {post.authorName || 'Íjász'}
                      </div>
                      <div style={{ fontSize: '0.75rem', color: '#888' }}>
                        {formatDate(post.createdAt)}
                      </div>
                    </div>
                  </div>
                  {isClub && (
                    <span style={clubBadgeStyle}>EGYESÜLET</span>
                  )}
                </div>

                {/* TARTALOM */}
                {post.title && (
                  <h3 style={{ margin: '0 0 8px 0', fontSize: '1.05rem', color: '#b30000' }}>
                    🏹 {post.title}
                  </h3>
                )}

                {(post.caption || post.content) && (
                  <p style={{ margin: '0 0 12px 0', fontSize: '0.95rem', color: '#333', lineHeight: '1.5', whiteSpace: 'pre-wrap' }}>
                    {post.caption || post.content}
                  </p>
                )}

                {/* CSATOLT KÉP */}
                {post.imageUrl && (
                  <div style={{ borderRadius: '10px', overflow: 'hidden', marginBottom: '12px', border: '1px solid #eee' }}>
                    <img src={post.imageUrl} alt="" style={{ width: '100%', maxHeight: '400px', objectFit: 'cover' }} />
                  </div>
                )}

                {/* CSATOLT VERSENY ADATLAP LINK (GOMB) */}
                {post.eventId && (
                  <div
                    onClick={() => navigate(`/verseny/${post.eventId}`)}
                    style={{
                      marginTop: '10px',
                      marginBottom: '12px',
                      padding: '10px 14px',
                      backgroundColor: '#fff5f5',
                      border: '1px solid #b30000',
                      borderRadius: '8px',
                      color: '#b30000',
                      fontWeight: 'bold',
                      fontSize: '0.9rem',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      cursor: 'pointer'
                    }}
                    title="Kattints a verseny részleteinek megtekintéséhez és nevezéshez"
                  >
                    <span>🎯 Verseny megtekintése és Nevezés</span>
                    <span>→</span>
                  </div>
                )}

                {/* CSATOLT EDZÉS KÁRTYA A HÍRFOLYAMBAN */}
                {(post.totalScore !== undefined || post.workoutName) && (
                  <div
                    onClick={() => {
                      sessionStorage.setItem('viewing_shared_workout', JSON.stringify(post));
                      navigate(`/edzes/${post.id}?viewShared=true`);
                    }}
                    style={{ backgroundColor: '#f8f9fa', border: '1px solid #e0e0e0', borderRadius: '10px', padding: '12px 15px', marginBottom: '12px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer', transition: 'background-color 0.2s' }}
                    title="Kattints az edzés megtekintéséhez"
                  >
                    <div>
                      <div style={{ fontWeight: 'bold', color: '#b30000', fontSize: '0.95rem' }}>🏹 {post.workoutName || 'Edzés'}</div>
                      <div style={{ fontSize: '0.8rem', color: '#555', marginTop: '2px' }}>
                        Pontszám: <strong>{post.totalScore || 0}</strong> | Átlag: <strong>{post.averageArrowScore?.toFixed(2) || '0.00'}</strong>
                      </div>
                    </div>
                  </div>
                )}

                {/* REAKCIÓK ÉS 3 PÖTTY MENÜ GOMB SÁV */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '10px', borderTop: '1px solid #f0f0f0' }}>
                  {/* KOMPAKT EMOJI + SZÁM JELVÉNYEK (EGYESÜLETI POSZTOKNÁL 1:1 APPSZINTEN: likes=🎯, congrats=👍, wow=🔥) */}
                  <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', alignItems: 'center' }}>
                    {isClub ? (
                      <>
                        {likesCount > 0 && (
                          <span style={{ ...readOnlyReactionBadgeStyle, backgroundColor: '#e6fffa', borderColor: '#b2f5ea', color: '#28a745' }}>
                            🎯 {likesCount}
                          </span>
                        )}
                        {congratsCount > 0 && (
                          <span style={readOnlyReactionBadgeStyle}>
                            👍 {congratsCount}
                          </span>
                        )}
                        {wowCount > 0 && (
                          <span style={{ ...readOnlyReactionBadgeStyle, backgroundColor: '#fff5f5', borderColor: '#feb2b2', color: '#e53e3e' }}>
                            🔥 {wowCount}
                          </span>
                        )}
                      </>
                    ) : (
                      <>
                        {likesCount > 0 && (
                          <span style={readOnlyReactionBadgeStyle}>🏹 {likesCount}</span>
                        )}
                        {congratsCount > 0 && (
                          <span style={{ ...readOnlyReactionBadgeStyle, backgroundColor: '#fffbe6', borderColor: '#ffe58f', color: '#d48806' }}>
                            🏆 {congratsCount}
                          </span>
                        )}
                        {wowCount > 0 && (
                          <span style={{ ...readOnlyReactionBadgeStyle, backgroundColor: '#fff5f5', borderColor: '#feb2b2', color: '#e53e3e' }}>
                            🔥 {wowCount}
                          </span>
                        )}
                        {goCount > 0 && (
                          <span style={{ ...readOnlyReactionBadgeStyle, backgroundColor: '#e6fffa', borderColor: '#b2f5ea', color: '#28a745' }}>
                            💪 {goCount}
                          </span>
                        )}
                      </>
                    )}
                  </div>

                  {/* FÜGGŐLEGES 3 PÖTTY GOMB (JOBB ALUL) */}
                  <div style={{ position: 'relative' }}>
                    <button
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        setActiveMenuPostId(activeMenuPostId === post.id ? null : post.id);
                      }}
                      style={{
                        background: 'none',
                        border: 'none',
                        color: '#888',
                        cursor: 'pointer',
                        padding: '6px',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                      title="Opciók"
                    >
                      <FiMoreVertical size={20} />
                    </button>

                    {/* POPUP OPCIÓK MENÜ */}
                    {activeMenuPostId === post.id && (
                      <div style={{
                        position: 'absolute',
                        bottom: '35px',
                        right: '0',
                        backgroundColor: 'white',
                        borderRadius: '10px',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
                        border: '1px solid #eee',
                        zIndex: 100,
                        minWidth: '160px',
                        overflow: 'hidden'
                      }}>
                        {isMyPost ? (
                          <>
                            <div
                              onClick={() => handleOpenEditModal(post)}
                              style={{ padding: '10px 14px', fontSize: '0.85rem', fontWeight: 'bold', color: '#333', display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', borderBottom: '1px solid #f0f0f0' }}
                            >
                              <FiEdit3 size={16} color="#007bff" />
                              <span>Szerkesztés</span>
                            </div>
                            <div
                              onClick={() => {
                                setPostToDelete(post);
                                setActiveMenuPostId(null);
                              }}
                              style={{ padding: '10px 14px', fontSize: '0.85rem', fontWeight: 'bold', color: '#b30000', display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}
                            >
                              <FiTrash2 size={16} color="#b30000" />
                              <span>Törlés</span>
                            </div>
                          </>
                        ) : isClub ? (
                          <>
                            <div
                              onClick={() => {
                                handleToggleReaction(post, 'going');
                                setActiveMenuPostId(null);
                              }}
                              style={{ padding: '10px 14px', fontSize: '0.85rem', fontWeight: 'bold', color: hasGoing ? '#28a745' : '#333', backgroundColor: hasGoing ? '#e6fffa' : 'transparent', display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', borderBottom: '1px solid #f0f0f0' }}
                            >
                              <FiTarget size={16} color={hasGoing ? '#28a745' : '#b30000'} />
                              <span>🎯 Ott leszek!</span>
                            </div>
                            <div
                              onClick={() => {
                                handleToggleReaction(post, 'interested');
                                setActiveMenuPostId(null);
                              }}
                              style={{ padding: '10px 14px', fontSize: '0.85rem', fontWeight: 'bold', color: hasInterested ? '#b30000' : '#333', backgroundColor: hasInterested ? '#fff5f5' : 'transparent', display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', borderBottom: '1px solid #f0f0f0' }}
                            >
                              <FiZap size={16} color={hasInterested ? '#b30000' : '#888'} />
                              <span>🔥 Érdekel</span>
                            </div>
                            <div
                              onClick={() => {
                                handleToggleReaction(post, 'likes');
                                setActiveMenuPostId(null);
                              }}
                              style={{ padding: '10px 14px', fontSize: '0.85rem', fontWeight: 'bold', color: hasLiked ? '#3182ce' : '#333', backgroundColor: hasLiked ? '#ebf8ff' : 'transparent', display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}
                            >
                              <FiThumbsUp size={16} color={hasLiked ? '#3182ce' : '#888'} />
                              <span>👍 Tetszik</span>
                            </div>
                          </>
                        ) : (
                          <>
                            <div
                              onClick={() => {
                                handleToggleReaction(post, 'likes');
                                setActiveMenuPostId(null);
                              }}
                              style={{ padding: '10px 14px', fontSize: '0.85rem', fontWeight: 'bold', color: hasLiked ? '#b30000' : '#333', backgroundColor: hasLiked ? '#fff5f5' : 'transparent', display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', borderBottom: '1px solid #f0f0f0' }}
                            >
                              <span>🏹 Tetszik</span>
                            </div>
                            <div
                              onClick={() => {
                                handleToggleReaction(post, 'congrats');
                                setActiveMenuPostId(null);
                              }}
                              style={{ padding: '10px 14px', fontSize: '0.85rem', fontWeight: 'bold', color: hasCongrats ? '#d48806' : '#333', backgroundColor: hasCongrats ? '#fffbe6' : 'transparent', display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', borderBottom: '1px solid #f0f0f0' }}
                            >
                              <span>🏆 Gratulálok</span>
                            </div>
                            <div
                              onClick={() => {
                                handleToggleReaction(post, 'wow');
                                setActiveMenuPostId(null);
                              }}
                              style={{ padding: '10px 14px', fontSize: '0.85rem', fontWeight: 'bold', color: hasWow ? '#e53e3e' : '#333', backgroundColor: hasWow ? '#fff5f5' : 'transparent', display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', borderBottom: '1px solid #f0f0f0' }}
                            >
                              <span>🔥 Szuper</span>
                            </div>
                            <div
                              onClick={() => {
                                handleToggleReaction(post, 'go');
                                setActiveMenuPostId(null);
                              }}
                              style={{ padding: '10px 14px', fontSize: '0.85rem', fontWeight: 'bold', color: hasGo ? '#28a745' : '#333', backgroundColor: hasGo ? '#e6fffa' : 'transparent', display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}
                            >
                              <span>💪 Hajrá</span>
                            </div>
                          </>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>

      {/* --- POSZT SZERKESZTÉSE KÉPPEL MODAL --- */}
      {editingPost && (
        <div style={modalOverlayStyle}>
          <div style={{ ...modalContentStyle, maxWidth: '500px', padding: '20px', textAlign: 'left' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px', borderBottom: '2px solid #b30000', paddingBottom: '8px' }}>
              <h3 style={{ margin: 0, color: '#b30000', fontSize: '1.2rem', fontWeight: 'bold' }}>Bejegyzés szerkesztése</h3>
              <div
                style={{ cursor: 'pointer', backgroundColor: '#f2f2f2', borderRadius: '50%', width: '30px', height: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                onClick={() => setEditingPost(null)}
              >
                <FiX size={18} color="#333" />
              </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <label style={{ fontSize: '0.85rem', fontWeight: 'bold', color: '#444' }}>Üzenet módosítása:</label>
              <textarea
                value={editCaptionInput}
                onChange={(e) => setEditCaptionInput(e.target.value)}
                style={{ ...textareaStyle, minHeight: '90px' }}
                rows={3}
              />

              {/* CSATOLT KÉP CSERÉJE / TÖRLÉSE */}
              <label style={{ fontSize: '0.85rem', fontWeight: 'bold', color: '#444', marginTop: '6px' }}>Csatolt kép módosítása:</label>
              {editImagePreview ? (
                <div style={{ position: 'relative', borderRadius: '8px', overflow: 'hidden', border: '1px solid #eee' }}>
                  <img src={editImagePreview} alt="Preview" style={{ width: '100%', maxHeight: '200px', objectFit: 'cover' }} />
                  <button
                    type="button"
                    onClick={handleRemoveEditImage}
                    style={removeImageButtonStyle}
                  >
                    <FiX size={16} />
                  </button>
                </div>
              ) : (
                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 14px', border: '1px dashed #b30000', borderRadius: '8px', backgroundColor: '#fff5f5', color: '#b30000', fontWeight: 'bold', cursor: 'pointer', justifyContent: 'center' }}>
                  <FiImage size={20} />
                  <span>Új kép kiválasztása a Galériából</span>
                  <input
                    ref={editFileInputRef}
                    type="file"
                    accept="image/*"
                    onChange={handleEditImageSelect}
                    style={{ display: 'none' }}
                  />
                </label>
              )}
            </div>

            <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end', marginTop: '20px' }}>
              <button
                type="button"
                onClick={() => setEditingPost(null)}
                style={cancelButtonStyle}
                disabled={isUpdatingPost}
              >
                Mégse
              </button>
              <button
                type="button"
                onClick={handleSavePostEdit}
                disabled={isUpdatingPost}
                style={saveButtonStyle}
              >
                {isUpdatingPost ? 'Mentés...' : 'Módosítások mentése'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* --- POSZT TÖRLESE MEGERŐSÍTŐ MODAL --- */}
      {postToDelete && (
        <div style={modalOverlayStyle}>
          <div style={{ ...modalContentStyle, maxWidth: '400px', textAlign: 'center', padding: '24px' }}>
            <FiAlertTriangle size={50} color="#b30000" style={{ marginBottom: '15px' }} />
            <h3 style={{ margin: '0 0 10px 0', color: '#333' }}>Bejegyzés törlése</h3>
            <p style={{ color: '#666', marginBottom: '25px', lineHeight: '1.5', fontSize: '0.9rem' }}>
              Biztosan törölni szeretnéd ezt a bejegyzést? <br/>
              A művelet végleges és nem vonható vissza.
            </p>
            <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
              <button
                type="button"
                onClick={() => setPostToDelete(null)}
                style={cancelButtonStyle}
              >
                Mégse
              </button>
              <button
                type="button"
                onClick={handleConfirmDeletePost}
                style={{ ...saveButtonStyle, backgroundColor: '#b30000' }}
              >
                Igen, törlöm
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// --- STÍLUSOK ---
const pageStyle = {
  backgroundColor: '#f4f6f8',
  minHeight: '100vh',
  boxSizing: 'border-box'
};

const headerStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '15px',
  marginBottom: '20px',
  paddingBottom: '12px',
  borderBottom: '1px solid #e0e0e0',
  maxWidth: '650px',
  margin: '0 auto 20px auto'
};

const backButtonStyle = {
  background: 'none',
  border: 'none',
  color: '#333',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  padding: '6px'
};

const cardStyle = {
  backgroundColor: 'white',
  borderRadius: '12px',
  padding: '16px',
  boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
  border: '1px solid #eee'
};

const avatarStyle = {
  width: '38px',
  height: '38px',
  borderRadius: '50%',
  backgroundColor: '#f0f0f0',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  overflow: 'hidden'
};

const textareaStyle = {
  width: '100%',
  padding: '10px 12px',
  borderRadius: '8px',
  border: '1px solid #ddd',
  fontSize: '0.9rem',
  resize: 'vertical',
  boxSizing: 'border-box',
  outline: 'none',
  fontFamily: 'inherit'
};

const submitButtonStyle = {
  padding: '8px 16px',
  backgroundColor: '#b30000',
  color: 'white',
  border: 'none',
  borderRadius: '8px',
  fontWeight: 'bold',
  fontSize: '0.85rem'
};

const removeImageButtonStyle = {
  position: 'absolute',
  top: '8px',
  right: '8px',
  backgroundColor: 'rgba(0,0,0,0.6)',
  color: 'white',
  border: 'none',
  borderRadius: '50%',
  width: '28px',
  height: '28px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer'
};

const loginButtonStyle = {
  display: 'inline-block',
  padding: '8px 20px',
  backgroundColor: '#b30000',
  color: 'white',
  textDecoration: 'none',
  borderRadius: '8px',
  fontWeight: 'bold',
  fontSize: '0.85rem'
};

const clubBadgeStyle = {
  backgroundColor: '#fff5f5',
  color: '#b30000',
  border: '1px solid #feb2b2',
  padding: '2px 8px',
  borderRadius: '12px',
  fontSize: '0.7rem',
  fontWeight: 'bold'
};

const reactionBarStyle = {
  display: 'flex',
  gap: '8px',
  flexWrap: 'wrap',
  paddingTop: '0px'
};

const reactionButtonStyle = {
  padding: '6px 12px',
  borderRadius: '20px',
  border: '1px solid #eee',
  fontSize: '0.8rem',
  fontWeight: 'bold',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  gap: '5px',
  transition: 'all 0.15s ease'
};

const readOnlyReactionBadgeStyle = {
  padding: '5px 12px',
  borderRadius: '16px',
  backgroundColor: '#fff5f5',
  border: '1px solid #feb2b2',
  color: '#b30000',
  fontSize: '0.8rem',
  fontWeight: 'bold',
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px'
};

const modalOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.6)',
  backdropFilter: 'blur(3px)',
  zIndex: 10005,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '15px'
};

const modalContentStyle = {
  backgroundColor: 'white',
  borderRadius: '16px',
  boxShadow: '0 10px 30px rgba(0,0,0,0.25)',
  width: '100%'
};

const cancelButtonStyle = {
  flex: 1,
  padding: '10px',
  border: 'none',
  backgroundColor: '#eee',
  color: '#555',
  borderRadius: '8px',
  fontWeight: 'bold',
  cursor: 'pointer'
};

const saveButtonStyle = {
  flex: 1,
  padding: '10px',
  border: 'none',
  backgroundColor: '#b30000',
  color: 'white',
  borderRadius: '8px',
  fontWeight: 'bold',
  cursor: 'pointer'
};

export default SocialFeed;
